import { registerCollectionItemsQuery } from 'marketplace-ui-common/collections/queries/collectionItemsQuery';
import { appCollectionItemsResponseSchema } from 'marketplace-ui-client-types/marketplace-quality-customer-service-v1/schema';
export const GET_THEME_COLLECTION_ITEMS = registerCollectionItemsQuery({
  offeringType: 'THEME',
  fieldName: 'themeCollectionItems',
  schema: appCollectionItemsResponseSchema
});